import { CategoriesPage } from './pages/CategoriesPage';

export const categoriesRoutes = {
  path: 'categories',
  children: [{
    path: '',
    element: <CategoriesPage />,
  }],
};

